var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column justify-center align-center pa-7"},[_c('v-icon',{attrs:{"size":80,"color":"success"}},[_vm._v("mdi-check-circle-outline")]),_c('div',{staticClass:"mt-4 title"},[_vm._v(" "+_vm._s(_vm.$tc('page.external.target_profile.finished.title'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }